import {Fade} from "react-reveal";
import React from "react";

const TextError = (props) => {
  return (
    <>
      <Fade bottom>
        <div className="error">
          {props.children}
        </div>
      </Fade>
    </>
  )
}

export default TextError;